import {
  fetchGetSpamChatsDesktop,
  IGetSpamChatsDesktopRequest,
  TGetSpamChatsDesktopResponse,
} from '../repositories/chats/v1/get-spam-chats-desktop';
import { TContext } from '../types/context';

type TFetchSpamChatsParams = {
  parameters: IGetSpamChatsDesktopRequest;
  cookies?: string;
};

export async function fetchSpamChats({ logger, httpApi }: TContext, { cookies, parameters }: TFetchSpamChatsParams) {
  try {
    const { response, statusCode }: TGetSpamChatsDesktopResponse = await fetchGetSpamChatsDesktop({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      return null;
    }

    return response.chats;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchSpamChats.ts [fetchSpamChats]',
      message: 'Не удалось получить список спам чатов',
    });

    return null;
  }
}
